<template>
    <Authlayout :loading="!mostrarContenido">
        <LoginForm
            v-if="!userTmp"
            :logo-empresa="empresa.logo"
            :disabled="disabledForm"
            :alert-exito="alertExito"
            :alert-error="alertError"
            :msj-respuesta="msjRespuesta"
            :list-errors="listErrors"
            :usuario="login.usuario"
            :clave="login.clave"
            @update:usuario="login.usuario = $event"
            @update:clave="login.clave = $event"
            @submit="autenticar"
        />
        <VerificationForm
            v-else
            :logo-empresa="empresa.logo"
            :disabled="disabledForm"
            :alert-exito="alertExito"
            :alert-error="alertError"
            :msj-respuesta="msjRespuesta"
            :list-errors="listErrors"
            :code="login.code"
            @update:code="login.code = $event"
            @submit="verificarCode"
            @resend="resendCode"
        />
    </Authlayout>
</template>

<script>
    import Authlayout from '@/layout/AuthLayout.vue';
    import LoginForm from '@/components/LoginForm.vue';
    import VerificationForm from '@/components/VerificationForm.vue';

    export default {
        components: {
            Authlayout,
            LoginForm,
            VerificationForm,
        },
        data() {
            return {
                login: {
                    usuario: '',
                    clave: '',
                    code: '',
                },
                empresa: {
                    logo: '',
                },
                msjRespuesta: '',
                listErrors: [],
                disabledForm: false,
                alertExito: false,
                alertError: false,
                mostrarContenido: false,
                userTmp: this.$session.get('userTmp', null),
            };
        },
        watch: {
            userTmp(newVal) {
                this.userTmp = newVal;
                this.$session.set('userTmp', newVal);
            },
        },

        methods: {
            getDatos() {
                this.axios({
                    method: 'POST',
                    url: 'api/panel/login/index',
                })
                    .then((response) => {
                        if (response.status === 200) {
                            let empresa = response.data.data.empresa;
                            if (empresa.logo != null) {
                                this.empresa.logo = this.assetAWS('perfil_tienda/logo/' + empresa.logo);
                            }
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .then(() => {
                        this.mostrarContenido = true;
                    });
            },

            handleCatchError(error) {
                this.alertError = true;

                if (error.response) {
                    const { status, data } = error.response;

                    if (status === 422 && data.errors) {
                        this.listErrors = Object.values(data.errors);
                        this.msjRespuesta = '';
                    } else if (status === 400 && data.mensaje) {
                        this.msjRespuesta = data.mensaje;
                        this.listErrors = [];
                    } else {
                        this.msjRespuesta = 'Ocurrió un error inesperado. Por favor, inténtelo de nuevo más tarde.';
                        this.listErrors = [];
                    }
                } else {
                    this.msjRespuesta = 'Ocurrió un error inesperado. Por favor, inténtelo de nuevo más tarde.';
                    this.listErrors = [];
                }
            },

            async autenticar() {
                this.listErrors = [];
                this.disabledForm = true;
                this.alertError = false;
                this.alertExito = false;

                try {
                    const res = await this.axios.post('api/panel/login/autenticar', this.login);
                    const { mensaje, usuario } = res.data;

                    this.alertExito = true;
                    this.msjRespuesta = mensaje;
                    this.userTmp = usuario;
                } catch (err) {
                    this.handleCatchError(err);
                } finally {
                    this.disabledForm = false;
                }
            },

            async verificarCode() {
                this.listErrors = [];
                this.disabledForm = true;
                this.alertError = false;
                this.alertExito = false;

                try {
                    const res = await this.axios.post('api/panel/login/verificar-codigo', {
                        code: this.login.code,
                        id: this.userTmp.id,
                    });
                    const { mensaje, usuario, token } = res.data;

                    this.alertExito = true;
                    this.msjRespuesta = mensaje;
                    this.$session.set('token', token);
                    this.$session.set('usuario', usuario);

                    this.getRolesPermisos();
                } catch (err) {
                    this.handleCatchError(err);
                } finally {
                    this.disabledForm = false;
                }
            },
            async resendCode() {
                this.listErrors = [];
                this.disabledForm = true;
                this.alertError = false;
                this.alertExito = false;

                try {
                    const res = await this.axios.post('api/panel/login/reenviar-codigo', { id: this.userTmp.id });
                    const { mensaje } = res.data;

                    this.alertExito = true;
                    this.msjRespuesta = mensaje;
                } catch (err) {
                    this.handleCatchError(err);
                } finally {
                    this.disabledForm = false;
                }
            },

            getRolesPermisos() {
                this.axios
                    .post('api/panel/login/getRolesPermisos')
                    .then((res) => {
                        let jsPermissions = res.data.jsPermissions;
                        this.$session.set('jsPermissions', jsPermissions);
                    })
                    .catch((err) => {
                        console.error(err.response);
                    })
                    .then(() => {
                        location.reload();
                    });
            },
        },
        created() {
            this.getDatos();

            if (this.$session.exists('userTmp')) {
            }
        },
    };
</script>

<style scoped></style>
